'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { type OneTrustGroups, onOneTrustGroupsUpdated } from '../../utils';
import { hasGoogleMapsConsent } from './hasGoogleMapsConsent';
export const useGoogleMapsConsent = () => {
  const $ = _c(2);
  const [canLoadGoogleMaps, setCanLoadGoogleMaps] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const readConsent = t2 => {
        const groups = t2 === undefined ? window.OnetrustActiveGroups : t2;
        setCanLoadGoogleMaps(hasGoogleMapsConsent(groups));
      };
      readConsent();
      return onOneTrustGroupsUpdated(readConsent);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return canLoadGoogleMaps;
};